import api from './axios';

const employeeApi = {
  getEmployees: (params) => {
    return api.get('/employees', { params });
  },

  getEmployee: (id) => {
    return api.get(`/employees/${id}`);
  },

  createEmployee: (data) => {
    return api.post('/employees', data);
  },

  updateEmployee: (id, data) => {
    return api.put(`/employees/${id}`, data);
  },

  deleteEmployee: (id) => {
    return api.delete(`/employees/${id}`);
  }
};

export default employeeApi;
